// extracted by css-extract-rspack-plugin
export default {"sidebar":"CodeViewFileTreeLayout-module__sidebar__n_Aau","heading":"CodeViewFileTreeLayout-module__heading__A1Iqk"};